import React  from 'react';
import cn from 'classnames';

export default function StarRating({className, numberStars = 10, onResult, name}) {
  const arrStars = Array.from(Array(numberStars).keys());
  const onChange = (e) => onResult(e.target.value);

  return (
    <div className={cn(className, "star-rating")}>
      {arrStars.map((_, index) => {
        const idStar = arrStars.length - index;

        return (
          <React.Fragment key={idStar}>
            <input type="radio" id={`${name}-${idStar}`} name={name} value={idStar} onChange={onChange} />
            <label htmlFor={`${name}-${idStar}`} />
          </React.Fragment>
        );
      })}
    </div>
  );
};
